module.exports = __webpack_public_path__ + "static/bouchier-logo-cfe8c76079d4eaa8ec2c93da962929e1.jpeg";